import { useLocation } from "react-router-dom";
import { StepIndicator } from "../components/Atoms/StepIndicator";
import {
  AGENDAMENTO_V2_STEPS,
  getStepFromPath,
} from "../routes/agendamentoV2Steps";
import { twMerge } from "tailwind-merge";

export const useAgendamentoStepIndicator = (className?: string) => {
  const location = useLocation();
  const activeStep = getStepFromPath(location.pathname);

  if (!activeStep) {
    return null;
  }

  return (
    <StepIndicator
      steps={AGENDAMENTO_V2_STEPS}
      activeStep={activeStep}
      className={twMerge("hidden md:flex", className)}
    />
  );
};
